import { Box, Button, Grid, Typography, TextField, Breadcrumbs, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { HttpRequest } from "../HttpRequest";
import { ArrowBackIos, Circle, EditOutlined } from "@mui/icons-material";
import CustomInputLabel from "../common/CustomInputLabel";
import { SuccessAlert } from "../common/snackbar/success";
import { ErrorAlert } from "../common/snackbar/error";
import CustomSearchInput from "../common/CustomSearchInput";
import warningIcon from '../../images/warning-remove-icn.svg';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid } from "@mui/x-data-grid";
import secureLocalStorage from "react-secure-storage";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ReusableModal from "../common/ReusableModal";

const VariationsComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [search, setSearch] = useState('');
  const [successShow, setSuccessShow] = useState({ state: false, message: "" })
  const [errorShow, setErrorShow] = useState({ state: false, message: "" })
  const [showAddVariationModal, setShowAddVariationModal] = useState(false)
  const [showEditVariationModal, setShowEditVariationModal] = useState(false)
  const [variationFormdata, setVariationFormdata] = useState({
    variationName: "",
    variationValues: "",
  })
  const [variation, setVariation] = useState({});
  const [openDeleteVariation, setOpenDeleteVariation] = useState(false)
  const handleOpenDeleteVariation = () => { setOpenDeleteVariation(true) }
  const handleCloseDeleteVariation = () => { setOpenDeleteVariation(false) }
  const [dataGridPageSize, setPageSize] = useState(10);
  const [pageState, setPageState] = useState({ isLoading: false, data: [], total: 0, page: 1, pageSize: dataGridPageSize, })

  const handleFormData = (e) => {
    const { name, value } = e.target
    setVariationFormdata({ ...variationFormdata, [name]: value })
  }
  const handleRowClick = (event, params) => {
    event.stopPropagation();

    setVariationFormdata({
      variationName: params?.row?.variationName,
      variationValues: params?.row?.variationValues.join(','),
    });
    setVariation(params?.row);
    setShowEditVariationModal(true);
  }
  const columns = [
    {
      field: 'variationName', headerName: 'variation Name', flex: isMobile ? 1 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Variation Name </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          <Grid container spacing={2}>
            <Grid item>
              {params.row.variationName}
            </Grid>
          </Grid>
        </Box>)
      }
    },
    {
      field: 'variationValues', headerName: 'variation Description', flex: isMobile ? 1.5 : 2.5,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Variation Description   </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          {params.row.variationValues.length > 0 && (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {params.row.variationValues.map((item, index) => (
                <>
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box key={index} sx={{ minwidth: "57px", height: "34px", backgroundColor: "#efefef", borderRadius: "5px", padding: "5px 10px 5px 10px", marginLeft: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <Typography variant="h6" sx={{ color: "#707070", fontSize: "14px", fontStyle: "normal", fontWeight: "600" }}>
                        {item}
                      </Typography>
                    </Box>

                  </Box>
                </>
              ))}
            </Box>
          )}
        </Box>)
      }
    },
    {
      field: 'action', headerName: 'Action', flex: isMobile ? 0.8 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Action  </Box>) },
      renderCell: (params) => {
        const onClickDelete = (event) => {
          event.stopPropagation();
          setVariation(params.row);
          handleOpenDeleteVariation();
        }
        return (
          <Box style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "13px" : "25px", fontWeight: "500", marginTop: isMobile ? '5px' : '0' }}>
            <Tooltip title="Edit">
            <EditOutlined onClick={(event)=>handleRowClick(event,params)} sx={{ color: '#032541', marginRight: '10px', fontSize: isMobile ? '18px' : 'inherit' }} />
            </Tooltip>
            <Tooltip title="Delete">
            <DeleteIcon onClick={onClickDelete} sx={{ color: '#DC3545', fontSize: isMobile ? '18px' : 'inherit' }} />
            </Tooltip>
          </Box>
        )
      }
    },
  ]

  const getvariationData = useCallback(() => {
    const businessNumber = secureLocalStorage.getItem("businessId");
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/get_business_variations?businessNumber=${businessNumber}&searchValue=${search}`
    }).then((data) => {
      setPageState((prevState) => ({
        ...prevState,
        data: data?.response?.data,
        total: data?.response?.count,
        isLoading: false
      }))
    }).catch((error) => {
    });
  }, [search]);

  useEffect(() => {
    getvariationData()
  }, [search, getvariationData])

  const handleVariationAddSubmit = () => {
    if (!variationFormdata.variationName) {
      setErrorShow({ state: true, message: "Variation name is required" });
      return;
    }
    if (!variationFormdata.variationValues) {
      setErrorShow({ state: true, message: "Values are  required" });
      return;
    }
    let newData
    let newVariationValues = variationFormdata.variationValues.split(',')
    newData = { variationName: variationFormdata.variationName, variationValues: newVariationValues }
    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/business/addBusiness_variations`,
      body: newData

    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Variation added successfully" });
        setShowAddVariationModal(false)
        getvariationData()
        setVariationFormdata({
          variationName: "",
          variationValues: "",
        })
      } else {
        setErrorShow({ state: true, message: data.response?.message || data.response?.data?.message || "Error adding variation" });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: error?.message || "Error adding variation" });
    })
  }
  const handleVariationUpdateSubmit = () => {
    if (!variationFormdata.variationName) {
      setErrorShow({ state: true, message: "Variation name is required" });
      return;
    }
    if (!variationFormdata.variationValues) {
      setErrorShow({ state: true, message: "Values are  required" });
      return;
    }
    let newData
    let newVariationValues = variationFormdata.variationValues.split(',')
    newData = { variationName: variationFormdata.variationName, variationValues: newVariationValues }
    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/business/editBusiness_variations/${variation._id}`,
      body: newData
    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Variation updated successfully" });
        setShowEditVariationModal(false)
        getvariationData()
        setVariationFormdata({
          variationName: "",
          variationValues: "",
        })
      } else {
        setErrorShow({ state: true, message: data.response?.message || data.response?.data?.message || "Error updating variation" });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: error?.message || "Error updating variation" });
    })
  }
  const handleDeleteVariation = (id) => {
    handleCloseDeleteVariation();
    HttpRequest({
      method: 'DELETE',
      url: `/api/v1/ecommerce/business/deleteBusiness_variations/${id}`,
    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Variation deleted successfully" });
        setVariation({});
        getvariationData();
      } else {
        setErrorShow({ state: true, message: data.response?.message || data.response?.data?.message || "Error deleting variation" });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: error?.message || "Error deleting variation" });
    })
  }

  const breadcrumbs = [
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem", ml: isMobile ? 0 : 3 }}>
          Dashboard
      </Typography>,
      <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
      Variations
      </Typography>
    ];
  return (
    <Box sx={{ mt: { xs: "15%", sm: "4%" }, pr: { xs: 2, sm: "3.5%" }, width: { xs: "100vw", sm: "calc(100vw - 355px)" }, maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box",  px: { xs: 2, sm: 0 },  ml: { xs: -3, sm: 0 } }}>      
      <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
      <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
      
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
        <Box sx={{ flexDirection: "column", flex: 1 }}>
          <Box >
            {showAddVariationModal || showEditVariationModal ? (
              <Box variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
                <ArrowBackIos sx={{ width: '25px', height: '35px', objectFit: 'contain',}} onClick={() => { setShowEditVariationModal(false); setShowAddVariationModal(false); }} />
                <Typography sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>Add Variation</Typography>
              </Box>
            ) : (
              <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600", pb: 1 }}>
                Variations
              </Typography>
            )}
          </Box>
          <Box>
            <Grid item sx={{ mt: 1, mb: { xs: 1, sm: 1 }, ml: { sm: -3 } }}>
              <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: { xs: "11px", sm: "13px" } }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
                {breadcrumbs}
              </Breadcrumbs>
            </Grid>
            <Typography variant="h4" sx={{ color: "#707070", fontSize: { xs: "12px", sm: "14px" }, fontStyle: "normal", fontWeight: "normal" }}   >
              View and manage your Variations
            </Typography>
          </Box>
        </Box>
        {showAddVariationModal || showEditVariationModal ? null :
          <Box sx={{ width: { xs: '100%', sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>
            <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setShowAddVariationModal(true)}>
              Add Variation
            </Button>
          </Box>
        }
      </Box>
      {showAddVariationModal || showEditVariationModal ? null :
        <Box sx={{ display: 'flex', mt: 2 }}>
          <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
            <CustomSearchInput placeholder={"Search variation name ...."} name="search" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: '100%', sm: 'auto' } }} />
          </Box>
        </Box>
      }
      {showAddVariationModal ? <>
        <Box sx={{ width: { xs: "100%", sm: "500px" }, mt: 2 }}>
          <Box sx={{ width: "100%", marginTop: "20px" }}>
            <CustomInputLabel label={"Variation Name"} name={"variationName"} required={true} />
            <Typography variant="h5" sx={{ color: "#707070", fontSize: { xs: "11px", sm: "12px" }, fontStyle: "normal", fontWeight: "600" }}>
              Name is the attribute of the variation e.g Size, Color
            </Typography>
            <TextField label="Variation Name" value={variationFormdata?.variationName} name="variationName" onChange={handleFormData} sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
          </Box>

          <Box sx={{ width: "100%", marginTop: "20px" }}>
            <CustomInputLabel label={"variationValues"} name={"variationValues"} required={true} />
            <Typography variant="h5" sx={{ color: "#707070", fontSize: { xs: "11px", sm: "12px" }, fontStyle: "normal", fontWeight: "600" }}>
              Values are different attributes in the variation e.g Medium
            </Typography>
            <TextField label="Variation Values" value={variationFormdata?.variationValues} name="variationValues" onChange={handleFormData} sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
            <Box sx={{ marginTop: "5px", display: "flex", justifyContent: "flex-end", paddingBottom:"10px" }}>
              <Typography variant="h5" sx={{ color: "#707070", fontSize: { xs: "10px", sm: "12px" }, fontStyle: "normal", fontWeight: "600" }}>
                Separate multiple values with a comma "," e.g Medium, Large
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "end", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
            <Button variant="contained" sx={{ backgroundColor: "#fff", color: "#dc3545", textTransform: "none", borderRadius: "5px", border: "1px solid #dc3545", padding: "10.4px 30px 9.6px 30px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#fff", color: "#dc3545" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setShowAddVariationModal(false)}>
              Cancel
            </Button>

            <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={handleVariationAddSubmit}>
              Add Variation
            </Button>
          </Box>
        </Box>
      </> : ''
      }

      {showEditVariationModal ? <>
        <Box sx={{ width: { xs: "100%", sm: "500px" }, mt: 2 }}>
          <Box sx={{ width: "100%", marginTop: "20px" }}>
            <CustomInputLabel label={"Variation Name"} name={"variationName"} required={true} />
            <Typography variant="h5" sx={{ color: "#707070", fontSize: { xs: "11px", sm: "12px" }, fontStyle: "normal", fontWeight: "600" }}>
              Name is the attribute of the variation e.g Size, Color
            </Typography>
            <TextField label="Variation Name" value={variationFormdata?.variationName} name="variationName" onChange={handleFormData} sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
          </Box>

          <Box sx={{ width: "100%", marginTop: "20px" }}>
            <CustomInputLabel label={"variationValues"} name={"variationValues"} required={true} />
            <Typography variant="h5" sx={{ color: "#707070", fontSize: { xs: "11px", sm: "12px" }, fontStyle: "normal", fontWeight: "600" }}>
              Values are different attributes in the variation e.g Medium
            </Typography>
            <TextField label="Variation Values" value={variationFormdata?.variationValues} name="variationValues" onChange={handleFormData} sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
            <Box sx={{ marginTop: "5px", display: "flex", justifyContent: "flex-end" }}>
              <Typography variant="h5" sx={{ color: "#707070", fontSize: { xs: "10px", sm: "12px" }, fontStyle: "normal", fontWeight: "600", paddingBottom:"10px" }}>
                Separate multiple values with a comma "," e.g Medium, Large
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "end", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
            <Button variant="contained" sx={{ backgroundColor: "#fff", color: "#dc3545", textTransform: "none", borderRadius: "5px", border: "1px solid #dc3545", padding: "10.4px 30px 9.6px 30px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#fff", color: "#dc3545" },width: { xs: '100%', sm: 'auto' }}} onClick={() => setShowEditVariationModal(false)}>
              Cancel
            </Button>
            <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={handleVariationUpdateSubmit}>
              Update
            </Button>
          </Box>
        </Box>
      </> : ''
      }

      {showAddVariationModal || showEditVariationModal ? '' :
        <Box style={{ width: '100%', overflowX: 'auto', mt: 2 }}>
          <Box sx={{ minWidth: { xs: 800, sm: '100%' } }}>
          <DataGrid
            sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px',}}}
            rowCount={pageState?.total}
            pagination
            loading={pageState?.isLoading}
            page={pageState?.page - 1}
            pageSizeOptions={[1, 10, 20, 50, 100]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: dataGridPageSize,
                  page: pageState?.page - 1,
                },
              },
            }}
            pageSize={dataGridPageSize}
            onPaginationModelChange={(data) => {
              const { pageSize, page } = data;
              setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
              setPageSize(pageSize)
            }}
            paginationMode="server"
            columns={columns}
            rows={pageState?.data}
            getRowId={(row) => row._id}
          />
          </Box>
        </Box>
      }
      
      <ReusableModal open={openDeleteVariation} onClose={handleCloseDeleteVariation}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", pt: 4, px: 3,}}>
          <Box sx={{ mb: 2 }}>
            <img src={warningIcon} alt="warning" width={70} height={70} style={{ objectFit: "contain" }}/>
          </Box>
          <Typography sx={{ color: "#032541", fontFamily: "Poppins", fontWeight: 600, fontSize: { xs: "16px", sm: "18px" }, mb: 1.5, textAlign: "center",}}>
            Delete Variation?
          </Typography>
          <Typography sx={{ color: "#707070", fontFamily: "Poppins", fontSize: { xs: "12px", sm: "14px" }, mb: 2, textAlign: "center", }}>
            Selected variation will be deleted. This action cannot be undone.
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 3,}}>
            <Circle sx={{ width: "10px", height: "10px", color: "#0c253f", mr: 1 }} />
            <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "14px", sm: "16px" }, color: "#032541", textAlign: "center",}}>
              {variation?.variationName}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Button sx={{ height: "45px", width: "125px", borderRadius: "4px", backgroundColor: "#dc3545", color: "#fff", fontWeight: 600, fontSize: "14px", fontFamily: "Poppins", textTransform: "none", "&:hover": { backgroundColor: "#c82333" }}} onClick={() => handleDeleteVariation(variation._id)}>
              Delete
            </Button>
          </Box>
        </Box>
      </ReusableModal>
    </Box>
  )
}

export default VariationsComponent